
const api={ 
  //获取企业基本信息接口
  getCompanyDetail: process.env.baseURL + '/v1/enterprise/detail',
  //获取政策匹配表单
  getSearchForm: process.env.baseURL + '/policy/condition',
  //搜索匹配政策
  searchPolicy: process.env.baseURL + '/policy/matchPolicyByIndustryId',
  //政策申请-第三方机构列表
  getPolicySeviceList: process.env.baseURL + '/v1/ps/mechanism/list',
  //政策申请接口
  getPolicyApplyList: process.env.baseURL + '/v1/ps/policy/apply',
  //政策预审核接口
  getPolicyPreApplyList: process.env.baseURL + '/v1/ps/policy/pre/apply',
  //服务申请
  getServiceApplyList: process.env.baseURL + '/v1/ps/service/apply',
  //政策或服务咨询
  getPolicyTermsList: process.env.baseURL + '/serverOrder/createOrUpdate',
  //所属行业
  getChildrenList: process.env.baseURL + '/systemParam/getChildrenList',
  //查看用户信息
  getUserInfo: process.env.baseURL + '/v1/ps/userInfo',//是否其它页面跳转到此项目的时候，需要重新获取用户信息？

  /*登录*/
  login: process.env.baseURL +'/userLogin/adminLogin' , // 登录
  regist: process.env.baseURL +'/userLogin/createCompany' , // 企业/机构注册
  setPwd: process.env.baseURL +'/userLogin/forgetResetPassword',   // 忘记密码-修改密码
  resetPwd: process.env.baseURL +'/userLogin/appUpdatePassword',   // 用户登录后-修改密码
  resetAccount: process.env.baseURL +'/userLogin/appUpdateNumber',  // 用户登录后-修改账号
  getVerifyCode: process.env.baseURL +'/userLogin/validPhoneGetCode',   // 获取校验码- // phone，parkId，userType，smsType(1：注册。2：修改密码。3：更换手机号)
  checkVerifyCode: process.env.baseURL +'/userLogin/validPhoneCode',   // 检查校验码-只在忘记密码的时候

  /*列表*/
  //获取资讯informTypeId: 1  通知公告列表informTypeId: 2
  getInformationTextList: process.env.baseURL + '/information/list',
  //获取政策解读列表
  getPolicyList: process.env.baseURL + '/policy/list',
  //获取政策解读分类 get请求
  getPolicyTypeData: process.env.baseURL + '/policyType/list',
  //获取第三方服务分类
  getServiceBuyType: process.env.baseURL + '/thirdServiceType/list', 
  //获取第三方服务列表
  getServiceBuyList: process.env.baseURL + '/thirdService/list',
  //获取机构详情-服务产品列表
  getServiceProductList: process.env.baseURL + '/server/serverList', 
  //获取机构详情-1服务资质-2合作案例-3团队介绍列表
  getServiceStrength: process.env.baseURL + '/lptown/strength/list', 
  //获取机构列表
  // getInstitutionsList: process.env.baseURL + '/institution/list',//  全部
  getInstitutionsList: process.env.baseURL + '/institution/allListOfValidServer',//机构列表（有服务且审核通过的）
  getPolicyInstitutionsList: process.env.baseURL + '/institution/institutionListByPolicyId',//机构列表（根据政策或服务的id获取机构列表）


  //获取第三方机构分类列表
  getServiceTypeList: process.env.baseURL+'/serverType/serverTypeList',

  companyTypeListPark: process.env.baseURL+'/park/manage/getCompanyTypeByPark',

  //获取风采列表
  getNewTownStyleList: process.env.baseURL+'/newTownStyle/selectTownStyleList',
  //获取风采分类
  getNewTownStyleType: process.env.baseURL + '/newTownStyle/getStyleList', 
  //获取风采详情
  getNewStyleDetail:process.env.baseURL + '/newTownStyle/selectById', 
  //全文搜索
  getHyqElasticSearchList:process.env.baseURL + '/hyqElasticSearch/search', 
  
  
  /*操作*/
  //购买服务-（创建或修改订单接口）
  //serverOrderType 1申请  2咨询  3预审
  //serverOrderSource 1政策  2第三方服务  3服务(机构)  4其它
  bugSevice: process.env.baseURL + '/serverOrder/createOrUpdate',

  /*详情*/
  //获取首页-banner
  getBannerList: process.env.baseURL + '/content/setting/bannerList',
  //获取资讯详情
  getNewsDetailInfo: process.env.baseURL + '/information/detail',
  //获取申报通知详情
  getReportDetailInfo: process.env.baseURL + '/information/detail',
  //获取政策详情
  getPolicyDetailInfo: process.env.baseURL + '/policy/detail',
  //获取第三方服务详情
  getServiceDetail: process.env.baseURL + '/thirdService/detail',
  //获取机构详情
  getInstitutionDetail: process.env.baseURL + '/institution/detail',
  //获取机构-服务详情
  getServiceInfoDetail: process.env.baseURL + '/server/detail',

  //获取企业信息
  getCompanyInfo:process.env.baseURL + '/companyBase/getCompanyBase/detail',

  //增加阅读量
  incrPolicyCount:process.env.baseURL + '/policy/incrReadCount',
  incrInformCount:process.env.baseURL + '/information/incrReadCount',
  incrServerCount:process.env.baseURL + '/thirdService/incrReadCount',

  //获取图片验证码
  getImageCode:process.env.baseURL + '/captchaImage/imageCaptcha',
  //手机号获取园区
  getParkByPhone:process.env.baseURL + '/userLogin/getPark',
  //获取logo
  getWebLogos:process.env.baseURL + '/webLogo/webLogos',

  //获取科技型企业
  getTechMicroCompanyList:process.env.baseURL + '/systemParam/getListByEnglishKey',
  //新增政银企信息
  createBankOrder:process.env.baseURL + '/companyBankOrder/bankOrder/create',
}

export default api;



// WEBPACK FOOTER //
// ./src/apis/api.js